import React, { useContext } from 'react';
import { Grid, TextField } from '@mui/material';
import { MapContext } from '../MapContext';

const GeofenceControls = ({ canEdit }) => {
    const { fences, selectedIndex } = useContext(MapContext);
    const { instance } = fences[selectedIndex] || {};

    const handleChangeRadius = (event) => {
        if (!instance?.setRadius) return;
        instance.setRadius(parseFloat(event.target.value));
    };
    const showRadius = !!instance?.getRadius;

    return (
        <Grid item xs={6}>
            {showRadius && !!fences?.length && (
                <TextField
                    type="number"
                    label="Radius"
                    value={instance?.getRadius ? instance?.getRadius() : ''}
                    fullWidth
                    onChange={handleChangeRadius}
                    disabled={!canEdit}
                    // wrap
                />
            )}
        </Grid>
    );
};

export default GeofenceControls;
